import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { D3Service } from '../../services/d3.service';

@Component({
  selector: 'app-table-chart',
  templateUrl: './table-chart.component.html',
  styleUrls: ['./table-chart.component.css'],
  providers: [D3Service]
})
export class TableChartComponent implements OnInit {

  @Input()
  set _chartInput(value: []) {
    this.chartInput = value;
    if (this.chartInput.length > 0) {
      this.chartInput[0]['series'].forEach(s => {
        this.colorScheme.domain.push(s['color']);
      });
    }
  }

  @Input() isChangelog: boolean;

  chartInput = [];
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  showYAxisLabel = true;
  yAxisLabel = 'Prices';
  chartHeight = 800;
  view: any[] = [700, this.chartHeight];
  colorScheme = {
    domain: []
  };
  tickFormatting;

  @ViewChild('chartWrapper', {static: true}) chartWrapper: ElementRef;

  constructor(public d3: D3Service) {
    this.tickFormatting = (series) => {
      return series;
    };
  }

  ngOnInit() {
    this.view = [this.chartWrapper.nativeElement.offsetWidth, this.chartHeight];
  }
}
